import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-jet-black shadow-lg' : 'bg-transparent'
    }`}>
      <nav className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-12 h-12 bg-crimson rounded-lg flex items-center justify-center transform group-hover:scale-105 transition-transform">
              <i className="ri-plane-fill text-white text-2xl"></i>
            </div>
            <div className="flex flex-col">
              <span className="text-white font-heading font-bold text-xl leading-tight">TopUp</span>
              <span className="text-crimson font-heading font-semibold text-xs tracking-wider">CONCIERGE</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/') ? 'text-crimson' : 'text-white hover:text-crimson'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/tours" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/tours') ? 'text-crimson' : 'text-white hover:text-crimson'
              }`}
            >
              Tours & Experiences
            </Link>
            <Link 
              to="/dubai-tours" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/dubai-tours') ? 'text-crimson' : 'text-white hover:text-crimson'
              }`}
            >
              Dubai Tours
            </Link>
            <Link 
              to="/abu-dhabi-tours" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/abu-dhabi-tours') ? 'text-crimson' : 'text-white hover:text-crimson'
              }`}
            >
              Abu Dhabi Tours
            </Link>
            <Link 
              to="/services" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/services') ? 'text-crimson' : 'text-white hover:text-crimson'
              }`}
            >
              Services
            </Link>
            <Link 
              to="/about" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about') ? 'text-crimson' : 'text-white hover:text-crimson'
              }`}
            >
              About
            </Link>
            <Link 
              to="/contact" 
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/contact') ? 'text-crimson' : 'text-white hover:text-crimson'
              }`}
            >
              Contact
            </Link>
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href="tel:+971562022818" 
              className="text-white hover:text-crimson transition-colors cursor-pointer"
            >
              <i className="ri-phone-fill text-xl"></i>
            </a>
            <Link 
              to="/booking" 
              className="bg-crimson text-white px-6 py-2.5 rounded-md font-semibold text-sm hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Now
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white text-2xl cursor-pointer"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-jet-black border-t border-dark-grey py-4">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="text-white hover:text-crimson transition-colors px-4 cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                Home
              </Link>
              <Link to="/tours" className="text-white hover:text-crimson transition-colors px-4 cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                Tours & Experiences
              </Link>
              <Link to="/dubai-tours" className="text-white hover:text-crimson transition-colors px-4 cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                Dubai Tours
              </Link>
              <Link to="/abu-dhabi-tours" className="text-white hover:text-crimson transition-colors px-4 cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                Abu Dhabi Tours
              </Link>
              <Link to="/services" className="text-white hover:text-crimson transition-colors px-4 cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                Services
              </Link>
              <Link to="/about" className="text-white hover:text-crimson transition-colors px-4 cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                About
              </Link>
              <Link to="/contact" className="text-white hover:text-crimson transition-colors px-4 cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                Contact
              </Link>
              <Link to="/booking" className="bg-crimson text-white px-4 py-2.5 rounded-md font-semibold text-sm mx-4 text-center cursor-pointer" onClick={() => setIsMobileMenuOpen(false)}>
                Book Now
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
